export const SITE_ORIGIN = 'https://langsi.online'

export const buildCanonical = (path = '/') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${SITE_ORIGIN}${normalizedPath === '/' ? '/' : normalizedPath}`
}

export const defaultSeo = {
  path: '/',
  title: '语博仕朗思｜LanguageCert B2/C1 备考、AI口语测评与在线模考平台',
  description:
    '语博仕朗思提供 LanguageCert 朗思考试 B2/C1 备考服务，覆盖 AI 口语测评、写作批改、在线模考、题型练习、阶段测评与学习反馈。',
  keywords: '朗思考试,LanguageCert,AI朗思,朗思在线模考,朗思写作批改,朗思口语测评,朗思练习题库',
  canonical: buildCanonical('/'),
  robots: 'index, follow',
  ogType: 'website'
}

export const seoPages = {
  home: defaultSeo,
  aiLangsi: {
    path: '/ai-langsi',
    title: 'AI朗思学习平台｜LanguageCert口语测评、写作批改与在线模考 - 语博仕朗思',
    description:
      '语博仕朗思提供面向 LanguageCert B2/C1 的 AI 口语测评、AI 写作批改、在线模考和题库练习，帮助考生高效完成朗思备考。',
    keywords: 'AI朗思,朗思AI模考,朗思AI口语测评,朗思AI写作批改,LanguageCert AI学习',
    canonical: buildCanonical('/ai-langsi'),
    robots: 'index, follow',
    ogType: 'article'
  },
  languageCertStudy: {
    path: '/languagecert-study',
    title: 'LanguageCert学习指南｜朗思B2/C1备考路线、题型与练习方法 - 语博仕朗思',
    description:
      '了解 LanguageCert 朗思考试的 B2/C1 备考路线、听说读写题型、学习方法、模考安排和题库练习方式，适合准备朗思考试的考生。',
    keywords: 'LanguageCert学习,LanguageCert备考,朗思学习,朗思考试备考,朗思B2备考,朗思C1备考',
    canonical: buildCanonical('/languagecert-study'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiQuestionBank: {
    path: '/langsi-question-bank',
    title: '朗思练习题库｜LanguageCert B2/C1 听力阅读写作口语练习与解析 - 语博仕朗思',
    description:
      '语博仕朗思整理 LanguageCert B2/C1 听力、阅读、写作、口语练习题库，提供在线练习、答案解析、模考训练和备考路径建议。',
    keywords: '朗思练习题库,朗思题库,朗思B2练习,朗思C1练习,LanguageCert练习题',
    canonical: buildCanonical('/langsi-question-bank'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiSpeakingBank: {
    path: '/langsi-speaking-bank',
    title: '朗思口语题库｜LanguageCert B2/C1 Part1-Part4 话题练习与AI测评 - 语博仕朗思',
    description:
      '语博仕朗思提供 LanguageCert 朗思口语 B2/C1 题库练习，覆盖 Part1-Part4 话题、录音练习、答案参考和 AI 口语测评。',
    keywords: '朗思口语题库,朗思口语练习,LanguageCert口语,AI口语测评,朗思口语Part1',
    canonical: buildCanonical('/langsi-speaking-bank'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiWritingCorrection: {
    path: '/langsi-writing-correction',
    title: '朗思写作批改｜LanguageCert B2/C1写作范文、思路与AI批改 - 语博仕朗思',
    description:
      '语博仕朗思提供 LanguageCert B2/C1 写作练习、范文思路、AI 写作批改和老师批改服务，帮助考生提升任务回应、语法、词汇和逻辑。',
    keywords: '朗思写作批改,LanguageCert写作,朗思写作范文,AI写作批改,朗思作文批改',
    canonical: buildCanonical('/langsi-writing-correction'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiCommonProblem: {
    path: '/langsiCommonProblem',
    title: '朗思考试常见问题｜报名、考试流程、设备网络与院校要求 - 语博仕朗思',
    description:
      '朗思考试常见问题解答，覆盖 LanguageCert 朗思报名流程、考场网络、线上考试过程、设备要求和院校语言要求。',
    keywords: '朗思常见问题,朗思考试报名,朗思考场问题,朗思院校要求,LanguageCert FAQ',
    canonical: buildCanonical('/langsiCommonProblem'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiWikipedia: {
    path: '/langsiwikipedia',
    title: '朗思百科｜LanguageCert听力阅读写作口语题型与备考方法 - 语博仕朗思',
    description:
      '语博仕朗思备考指南讲解 LanguageCert 朗思听力、阅读、写作、口语题型结构、备考方法和常见考试问题。',
    keywords: '朗思百科,LanguageCert题型,朗思听力,朗思阅读,朗思写作,朗思口语',
    canonical: buildCanonical('/langsiwikipedia'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiCourse: {
    path: '/langsicouse',
    title: '朗思课程｜LanguageCert B2/C1口语写作全科备考课程 - 语博仕朗思',
    description: '语博仕朗思提供 LanguageCert 朗思口语、写作、全科 1V1、阶段测评和模考训练课程，帮助 B2/C1 考生系统备考。',
    keywords: '朗思课程,LanguageCert课程,朗思1V1,朗思口语课程,朗思写作课程',
    canonical: buildCanonical('/langsicouse'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiCurriculum: {
    path: '/langsiCurriculum',
    title: '朗思口语冲刺班｜LanguageCert B2/C1口语课程详情 - 语博仕朗思',
    description: '朗思口语冲刺班面向 LanguageCert B2/C1 考生，提供课程章节、口语题型训练、话题练习和学习反馈信息。',
    keywords: '朗思口语冲刺班,朗思口语课程,LanguageCert口语,B2口语,C1口语',
    canonical: buildCanonical('/langsiCurriculum'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiWriting: {
    path: '/langsiWriting',
    title: '朗思写作训练营｜LanguageCert B2/C1写作课程详情 - 语博仕朗思',
    description: '朗思写作训练营面向 LanguageCert B2/C1 考生，提供写作课程章节、任务练习、结构训练和学习反馈信息。',
    keywords: '朗思写作训练营,朗思写作课程,LanguageCert写作,B2写作,C1写作',
    canonical: buildCanonical('/langsiWriting'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiPractice1v1: {
    path: '/langsiPractice1v1',
    title: '朗思全科1V1｜LanguageCert B2/C1个性化备考课程 - 语博仕朗思',
    description: '朗思全科 1V1 面向 LanguageCert B2/C1 考生，提供听力、阅读、写作、口语的个性化学习规划和训练安排。',
    keywords: '朗思全科1V1,LanguageCert1V1,朗思一对一,朗思B2备考,朗思C1备考',
    canonical: buildCanonical('/langsiPractice1v1'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiMouthSpecial: {
    path: '/langsiMouthSpecial',
    title: '朗思口语课程｜LanguageCert B2/C1口语冲刺训练 - 语博仕朗思',
    description: '语博仕朗思口语课程覆盖 B2/C1 口语题型、答题结构、话题练习和模考反馈，帮助考生提升表达稳定性。',
    keywords: '朗思口语课程,朗思口语冲刺班,LanguageCert口语,B2口语,C1口语',
    canonical: buildCanonical('/langsiMouthSpecial'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiWritingSpecial: {
    path: '/langsiWritingSpecial',
    title: '朗思写作课程｜LanguageCert B2/C1写作训练营 - 语博仕朗思',
    description: '语博仕朗思写作训练营覆盖 LanguageCert B2/C1 写作思路、范文学习、结构训练和批改反馈。',
    keywords: '朗思写作课程,朗思写作训练营,LanguageCert写作,朗思写作范文',
    canonical: buildCanonical('/langsiWritingSpecial'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiCorrectionSpecial: {
    path: '/langsiCorrectionSpecial',
    title: '朗思写作批改专题｜LanguageCert作文批改与学习反馈 - 语博仕朗思',
    description: '语博仕朗思写作批改从任务回应、结构、语法、词汇和逻辑维度提供学习反馈，帮助考生定位写作问题。',
    keywords: '朗思写作批改,LanguageCert作文批改,朗思作文批改,AI写作批改',
    canonical: buildCanonical('/langsiCorrectionSpecial'),
    robots: 'index, follow',
    ogType: 'article'
  },
  langsiForecastSpecial: {
    path: '/langsiForecastSpecial',
    title: '朗思全科阶段测评｜LanguageCert B2/C1考前训练与模考复盘 - 语博仕朗思',
    description: '语博仕朗思全科阶段测评提供听力、阅读、写作、口语考前训练、模考复盘和备考建议。',
    keywords: '朗思阶段测评,朗思考前训练,LanguageCert备考,朗思模考复盘',
    canonical: buildCanonical('/langsiForecastSpecial'),
    robots: 'index, follow',
    ogType: 'article'
  }
}

export default seoPages
